module.exports = __webpack_public_path__ + "img/logo_small.da1b7ca4.png";